import React, { Children, cloneElement, ReactElement } from 'react'
import { useStickyFooter } from 'providers/StickyFooterProvider/StickyFooterProvider'
import { StickyFooterProps } from 'providers/StickyFooterProvider/Types'
import { mergeProps } from '@react-aria/utils'

interface Props {
  children: ReactElement<StickyFooterProps>
}

export const StickyFooter = ({ children }: Props) => {
  const { isFloating } = useStickyFooter()
  const child = Children.only(children)

  return (
    <>
      {cloneElement(child, {
        ...mergeProps({ isFloating }, child.props),
      })}
    </>
  )
}
